export default function moderationEntryLoader(step) {
  return {
    step: step,

    init() {
      this.setCurrentEntry();
      document.addEventListener('turbo:frame-load', (event) => {
        if (event.target.id === 'moderation-modal__entry-frame') {
          this.setCurrentEntry();
        }
      });
    },

    setCurrentEntry() {
      this.$dispatch('moderation-set-current-entry', { id: parseInt(this.$root.dataset.entryId) });
    },
  };
}
